<div class="record-wrapper position-relative">
    <div class="record d-flex flex-column" (click)="collapsed.set(!collapsed())">
        <div class="details">
            <div class="d-flex flex-column gap-2">
                <div class="d-flex align-items-center justify-content-between w-100">
                    <div class="d-flex align-items-center gap-2">
                        <p class="record-name nunito-bold">
                            {{record()?.name ?? record()?.reason}}
                        </p>
                        <div class="record-type-pill d-flex align-items-center justify-content-center" [ngClass]="this.record().type">
                            <p class="record-type nunito-medium">
                                {{getRecordType()}}
                            </p>
                        </div>
                        @if (record()?.intensity)
                        {
                            <div class="record-type-pill d-flex align-items-center justify-content-center">
                                <p class="record-type nunito-medium">
                                    {{'PATIENT_TIMELINE_INFORMATION.INTENSITY' | translate}}: {{record()?.intensity}}
                                </p>
                            </div>
                        }
                    </div>
                    @if (!!record().description || !!record()?.document || hasAnyAdditionalInformation())
                    {
                        <svg-icon src="assets/icons/chevron-down.svg" class="collapsed-icon d-flex align-items-center" [class.open]="!collapsed()" />
                    }
                </div>
                @if (record().chronicIllnessRelated)
                {
                    <div class="d-flex align-items-center gap-1">
                        <svg-icon src="assets/icons/info.svg" class="information-icon d-flex align-items-center" />
                        <p class="record-chronic-illness nunito-regular">
                            {{'PATIENT_TIMELINE_INFORMATION.CHRONIC_ILLNESS_RELATED' | translate}}
                        </p>
                    </div>
                }
            </div>
            <div [@recordHeightAnimation]="getCollapsedState()" class="extended-information d-flex row g-3">
                @if (hasAnyAdditionalInformation())
                {
                    <div class="col-4">
                        @if (record()?.name && record()?.reason)
                        {
                            <p class="information-label nunito-regular">
                                {{'PATIENT_TIMELINE_INFORMATION.REASON' | translate}}: {{record()?.reason}}
                            </p>
                        }
                        @if (record()?.clinician)
                        {
                            <p class="information-label nunito-regular">
                                {{'PATIENT_TIMELINE_INFORMATION.CLINICIAN' | translate}}: {{record()?.clinician}}
                            </p>
                        }
                        @if (record()?.specialty)
                        {
                            <p class="information-label nunito-regular">
                                {{'PATIENT_TIMELINE_INFORMATION.SPECIALTY' | translate}}: {{record()?.specialty}}
                            </p>
                        }
                        @if (record()?.frequency)
                        {
                            <p class="information-label nunito-regular">
                                {{'PATIENT_TIMELINE_INFORMATION.FREQUENCY' | translate}}: {{record()?.frequency}}
                            </p>
                        }
                        @if (record()?.examType)
                        {
                            <p class="information-label nunito-regular">
                                {{'PATIENT_TIMELINE_INFORMATION.EXAM_TYPE' | translate}}: {{record()?.examType}}
                            </p>
                        }
                    </div>
                }
                <div [ngClass]="hasAnyAdditionalInformation() ? 'col-8' : 'col-12'">
                    @if (record()?.description)
                    {
                        <p class="information-label nunito-regular">
                            {{record()?.description}}
                        </p>
                    }
                    @if (record()?.document && record()?.description)
                    {
                        <div class="py-2"></div>
                    }
                    @if (record()?.document)
                    {
                        <div class="document-container d-flex flex-column">
                            <div class="d-flex aling-items-center" (click)="openDocument($event)">
                                <p class="document-name nunito-semibold">
                                    {{record()?.document?.name}}
                                </p>
                                <div class="document-icon-container">
                                    <svg-icon src="assets/icons/file-download.svg" class="document-icon d-flex align-items-center" />
                                </div>
                                @if (loadingFile())
                                {
                                    <div class="spinner-border main-color" role="status"></div>
                                }
                            </div>
                            @if (record()?.document?.ocr)
                            {
                                <p class="document-ocr nunito-regular">
                                    {{record()?.document?.ocr}}
                                </p>
                            }
                        </div> 
                    }
                </div>
            </div>
        </div>
        <div class="date-information d-flex align-items-center justify-content-between gap-1">
            <div class="d-flex align-items-center gap-1">
                <p class="date nunito-medium">
                    {{getDate(record()?.date ?? record()?.startDate)}}
                </p>
                @if (record()?.endDate)
                {
                    <p class="date nunito-medium">/</p>
                    <p class="date nunito-medium">
                        {{getDate(record()?.endDate)}}
                    </p>
                }
            </div>
            @if (!record()?.startDate)
            {
                <p class="date nunito-medium">
                    {{getTime(record()?.date)}}
                </p>
            }
        </div>
    </div>
</div>
